import axios from 'axios';
import { useConfig } from '../config';

export function useViewProduct() {
	const { api } = useConfig();

	function sendViewProduct(productId: number) {
		const payload = {
			product: productId,
		};
		axios
			.post(`${api}products/viewed.json`, payload, {
				withCredentials: true,
			})
			// telemetry: nobody is waiting for it, but a rejection has to be taken somewhere
			.catch(() => undefined);
	}

	return { sendViewProduct };
}
